import { render, staticRenderFns } from "./GenericTag.vue?vue&type=template&id=90b533d0"
import script from "./GenericTag.vue?vue&type=script&lang=js"
export * from "./GenericTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports